<template>
  <div style="width:340px;height:340px;">{{msg}}</div>
</template>
<script>
export default {
  data() {
    return {
      msg: ""
    };
  },
  mounted() {
    this.go();
  },
  methods: {
    go() {
      this.msg = "";
      let query = this.$route.query;
      let typeid = query.typeid;
      let serverid = query.serverid;
      let clientid = query.clientid;
      let userid = query.userid;
      if (typeid == null || serverid == null || clientid == null) {
        this.msg = "您不能访问该页面";
        return;
      }
      let string =
        typeid +
        "." +
        serverid +
        "." +
        clientid +
        "." +
        (userid == null ? 0 : userid);
      let base64 = btoa(string);
      this.$router.push({ path: "/mWorkOrder?t=" + base64 });
    }
  }
};
</script>